'use strict';

// Edits one SimpleDuctData calc element: a lookup of value by head, stored as
// values: [{head, value}], sorted by head (getValue() interpolates between neighbours).
angular.module('enervexSalesappApp').controller('SimpleDuctDataCtrl', function($scope, SimpleDuctData, DuctDataGridUtil, $stateParams, Flash, $state, _) {
	$scope.ctx = {
		formChanged: false
	};

	function load(item) {
		$scope.item = item;
		// number inputs need real numbers, older data may hold numeric strings
		$scope.values = _.map(item.values || [], function(o) {
			return _.extend(_.clone(o), {
				head: DuctDataGridUtil.num(o.head),
				value: DuctDataGridUtil.num(o.value)
			});
		});
		$scope.ctx.formChanged = false;
	}

	if ($stateParams.id == "new") {
		load({
			code: '',
			ventbomCode: '',
			values: [{ head: null, value: null }]
		});
	} else {
		SimpleDuctData.get({
			id: $stateParams.id
		}).$promise.then(load);
	}

	$scope.changed = function() {
		$scope.ctx.formChanged = true;
	};
	$scope.addRow = function(index) {
		$scope.values.splice(index + 1, 0, { head: null, value: null });
		$scope.changed();
	};
	$scope.removeRow = function(index) {
		$scope.values.splice(index, 1);
		$scope.changed();
	};
	$scope.sortByHead = function() {
		$scope.values = _.sortBy($scope.values, function(o) {
			return o.head;
		});
		$scope.changed();
	};

	function isNumber(v) {
		return _.isNumber(v) && !_.isNaN(v);
	}

	function validate() {
		if (!$scope.item.code || $scope.item.code == '') {
			return "Code is required";
		}
		if ($scope.values.length == 0) {
			return "Add at least one value";
		}
		var bad = _.find($scope.values, function(o) {
			return !isNumber(o.head) || !isNumber(o.value);
		});
		if (bad) {
			return "Every head and value must be a number";
		}
		for (var i = 1; i < $scope.values.length; i++) {
			if ($scope.values[i].head < $scope.values[i - 1].head) {
				return "Heads must be in ascending order (use Sort by head)";
			}
		}
		return null;
	}

	$scope.save = function() {
		Flash.clear();
		var message = validate();
		if (message) {
			Flash.create('danger', '<strong>Error!</strong> ' + message, 0, {}, true);
			return;
		}
		var payload = _.omit(_.clone($scope.item), "__v", "type");
		payload.values = $scope.values;
		var p = $scope.item._id ? SimpleDuctData.update({ id: $scope.item._id }, payload).$promise : SimpleDuctData.save(payload).$promise;
		p.then(function(result) {
			Flash.create('success', '<strong>Success!</strong> Saved ' + result.code + '.', 0, {}, true);
			if (!$scope.item._id) {
				$state.go("simple-duct-data", { id: result._id }, { inherit: false, reload: true });
			} else {
				load(result);
			}
		}).catch(function(err) {
			var message = (err.data && err.data.message) || "There was an error saving";
			Flash.create('danger', '<strong>Error!</strong> ' + message, 0, {}, true);
		});
	};
});
